import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { applyMiddleware, compose, createStore } from "redux";
import thunk from "redux-thunk";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";

import registerServiceWorker from "./registerServiceWorker";

import "./style-layout.css";
import "./style-reset.css";
import "./general.css";
import "./fonts.css";
import reducers from "./_reducers";
import App from "./App";
import BrowserNotSupported from "./views/BrowserNotSupported";
import { head } from "lodash";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const enhancer = composeEnhancers(applyMiddleware(thunk));
const store = createStore(reducers, {}, enhancer);

const theme = createTheme({
    typography: {
        fontFamily: ["Rakuten Sans UI", "Trebuchet MS", "Trebuchet", "Arial", "Helvetica", "sans-serif"].join(",")
    },
    props: {
        MuiButtonBase: {
            disableRipple: true
            //disableFocusRipple: true
        },
        MuiButton: {
            disableRipple: true
            //disableFocusRipple: true
        },
        MuiButtonGroup: {
            disableRipple: true
            //disableFocusRipple: true
        }
    },
    palette: {
        primary: {
            light: "#fa4c2e",
            main: "#bf0000",
            dark: "#870000",
            contrastText: "#fff"
        },
        secondary: {
            light: "#2c2c2c",
            main: "#000",
            dark: "#000",
            contrastText: "#fff"
        },
        error: {
            light: "#ef5350",
            main: "#bf0000",
            dark: "#c62828",
            contrastText: "#fff"
        }
    },
    shape: {
        borderRadius: 0
    },
    overrides: {
        MuiBackdrop: {
            root: {
                backgroundColor: "#75757550"
            }
        },
        MuiOutlinedInput: {
            root: {
                "&.Mui-focused": {
                    outline: `2px solid #212121`,
                    "& .MuiOutlinedInput-notchedOutline ": {
                        borderColor: "unset",
                        borderWidth: "1px"
                    },
                    "&.Mui-error ": {
                        outline: `2px solid #bf0000`
                    },
                    "&.Mui-error fieldset": {
                        borderColor: "#bf0000",
                        borderWidth: "1px"
                    }
                }
            }
        },
        MuiInput: {
            root: {
                "&.Mui-focused": {
                    outline: `2px solid #212121`,
                    "& .MuiInput-notchedOutline ": {
                        borderColor: "unset",
                        borderWidth: "1px"
                    },
                    "&.Mui-error ": {
                        outline: `2px solid #bf0000`
                    },
                    "&.Mui-error fieldset": {
                        borderColor: "#bf0000",
                        borderWidth: "1px"
                    }
                }
            }
        },
        MuiButtonBase: {
            root: {
                boxShadow: "unset !important",
                "&.Mui-focusVisible": {
                    outline: `2px solid #212121`,
                    outlineOffset: `2px`
                },
                "&.Mui-disabled": {
                    borderColor: "#e0e0e0"
                }
            }
        },
        MuiMenuItem: {
            root: {
                height: "30px",
                minHeight: "unset"
                // minHeight: "auto"
            }
        }
    }
});

const browser = require("@browser-detection");

if (browser.name === "IE") {
    ReactDOM.render(<BrowserNotSupported />, document.getElementById("root"));
} else {
    ReactDOM.render(
        <Provider store={store}>
            <BrowserRouter basename={process.env.REACT_APP_BASE_URL} forceRefresh={!("pushState" in window.history)}>
                <ThemeProvider theme={theme}>
                    <App />
                </ThemeProvider>
            </BrowserRouter>
        </Provider>,
        document.getElementById("root")
    );
}

registerServiceWorker();
